import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { State } from '@k12/forms';
import { HouseholdRecordVm } from '@k12/models';
import { PhonePipe } from '@k12/pipes';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-household-info',
  standalone: true,
  imports: [CommonModule, PhonePipe],
  templateUrl: './household-info.component.html'
})
export class HouseholdInfoComponent {
  private _householdData: HouseholdRecordVm = {} as HouseholdRecordVm;

  @Input() set householdData(value: HouseholdRecordVm | null | undefined) {
    this._householdData = value ?? ({} as HouseholdRecordVm);
    this.buildFormattedAddress();
  }
  get householdData(): HouseholdRecordVm {
    return this._householdData;
  }

  @Input() states: State[] = [];

  formattedAddress: string;

  private buildFormattedAddress(): void {
    const data = this._householdData;
    const addressLines: string[] = [];

    if (data.address1) addressLines.push(data.address1);

    let cityStateZip = '';
    if (data.city) cityStateZip += data.city;
    if (data.state) cityStateZip += (cityStateZip ? ', ' : '') + data.state;
    if (data.zip) cityStateZip += (cityStateZip ? ' ' : '') + data.zip;
    if (cityStateZip) addressLines.push(cityStateZip);

    this.formattedAddress = addressLines.join('<br>');
  }

  getLastFourSsn(ssn?: string): string {
    if (!ssn) return 'XXXX';
    const digitsOnly = ssn.replaceAll(/\D/g, '');
    return digitsOnly.length >= 4 ? digitsOnly.slice(-4) : 'XXXX';
  }
  // Renders '-' until the Income Verification process writes a value, which is what distinguishes
  // "not yet verified" from a genuine $0 verified income.
  getVerifiedIncome(): string {
    const verifiedIncome = this.householdData?.verifiedIncome;
    if (verifiedIncome === null || verifiedIncome === undefined) return '-';

    return `$${verifiedIncome.toLocaleString()}`;
  }

  getFullName(): string {
    return (
      [this.householdData?.firstName, this.householdData?.middleName, this.householdData?.lastName]
        .filter(Boolean)
        .join(' ') || '-'
    );
  }
}
